import instance from '../../utils/axiosConfig';

export const actDevice = async (deviceData) => {
    try {
        const response = await instance.post('/api/v1/device/act', deviceData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateActAccountPassword = async (body) => {
    try {
        const response = await instance.post('/api/v1/device/change/password', body);
        return response.data;
    } catch (error) {
        throw error;
    }
};
